import { atom } from "jotai";
import { type UserEntity } from "@/api/__generated__/orval/auth";

export const userAtom = atom<UserEntity | null | undefined>(null);
